/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type WorkforceOptimizationEntryPointComponent = EntryPointComponent<
	Record<string, never>,
	{},
	{},
	{ projectKey: string }
>;

export const workforceOptimizationEntryPoint: EntryPoint<
	WorkforceOptimizationEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<WorkforceOptimizationEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-workforce-optimization", jiraSpaEntry: "async-servicedesk-workforce-optimization" */ './WorkforceOptimizationPage.tsx',
	),
	getPreloadProps: ({ context: { match } }: EntryPointRouteParams) => {
		const projectKey = match.params.projectKey ?? '';

		return {
			queries: {},
			extraProps: { projectKey },
		};
	},
});
